/**
 * Route paths shared between the router and the pages behind them. They live here
 * rather than in RouterPage so a page can read its own path without importing the
 * router back — that cycle leaves the constant undefined at module-init time.
 */
export const monitoringOrderPaths = {
   /** Matches the `path` the menu API registers the row under. */
   path: "/order/management-order-monitoring",
   /** The row's `extra.route` — what the side menu actually navigates to. */
   aliasPath: "/monitoring-order",
   /** Notification tag fragment, following the tasking list's convention. */
   notificationTag: "order/management-order-monitoring",
};

/** The tasking list — the other list that opens the shared order detail/edit pages. */
export const taskingOrderPaths = {
   path: "/order/management-tasking",
};

/**
 * `OrderTaskingDetail` and `EditOrderTasking` are mounted under both the tasking
 * list and the monitoring list, so their first breadcrumb has to name whichever
 * list the URL actually belongs to instead of always claiming the tasking one.
 * Returns the i18n key for the crumb's label and the list path it links back to.
 */
export const resolveOrderListCrumb = (pathname: string) =>
{
   const monitoringBase = [
      monitoringOrderPaths.path,
      monitoringOrderPaths.aliasPath,
   ].find((base) => pathname === base || pathname.startsWith(`${base}/`));

   return monitoringBase
      ? { labelKey: "Monitoring Orders", path: monitoringBase }
      : { labelKey: "Tasking Orders", path: taskingOrderPaths.path };
};
